import Box from 'components/atomic/atoms/box'
import Text from 'components/atomic/atoms/text'
import CodeBlock from 'components/atomic/molecules/code-block'
import SharedTabs from 'components/pages/frameworks/@shared/tabs'

export type TemplateCodeExampleProps = {
  title?: string
  subTitle?: string
  framework: string
  examples: {
    title: string
    description: string
    code: string
    language?: string
  }[]
}

const TemplateCodeExamples = ({
  title,
  subTitle,
  framework,
  examples = []
}: TemplateCodeExampleProps) => {
  return (
    <Box css={{ spaceY: 10 }}>
      <Box relative textCenter css={{ spaceY: 10 }}>
        <Box textCenter css={{ spaceY: 4, '@md': { container: 'lg' } }}>
          <Text
            as="h2"
            size={{ '@initial': '3xl', '@md': '4xl' }}
            weight="semiBold"
          >
            {title ? title : `Grafbase + ${framework}`}
          </Text>
          <Text as="p" color="text2" size={{ '@initial': 'md', '@md': 'lg' }}>
            {subTitle
              ? subTitle
              : `${framework} gives you all the tools you need to build production
            scale applications. Whether you need to fetch data on the server, at
            build time when creating a static export, or caching on demand, 
            ${framework} has you covered.`}
          </Text>
        </Box>
      </Box>
      <SharedTabs
        tabs={examples.map(
          ({ description, code, language = 'jsx', title }, index) => ({
            current: index === 0,
            title,
            content: (
              <Box css={{ spaceY: 4 }}>
                <Text color="text2" size="sm" weight="medium">
                  {description}
                </Text>
                <Box css={{ bgc: '$bg2', borderRadius: '$lg', p: '$3' }}>
                  <CodeBlock language={language}>{code}</CodeBlock>
                </Box>
              </Box>
            )
          })
        )}
      />
    </Box>
  )
}

export default TemplateCodeExamples
